import { applyMiddleware, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import monitorReducersEnhancer from './enhancers/monitorReducers';
import loggerMiddleware from './middleware/logger';
import rootReducer from './reducers';

const configureStore = (preloadedState: {}): Store => {
  if (process.env.NODE_ENV === 'development' && module.hot) {
    const middlewares = [loggerMiddleware, thunkMiddleware];
    const middlewareEnhancer = applyMiddleware(...middlewares);

    const enhancers = [middlewareEnhancer, monitorReducersEnhancer];
    const composedEnhancers = composeWithDevTools(...enhancers);

    const store: Store = createStore(
      rootReducer,
      preloadedState,
      composedEnhancers
    );

    module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));

    return store;
  } else {
    const store = createStore(
      rootReducer,
      preloadedState,
      applyMiddleware(thunkMiddleware)
    );

    return store;
  }
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.ts